<template>
    <div class="loading-body" v-if="isShow">
        <div class="loading-msg">
            <img :src="images.loading" />
            <p>ロード中...</p>
        </div>
    </div>
</template>
<script>
import images from '../images'
export default {
    data () {
        return {
            isShow: false,
            images
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            this.isShow = true
            this.loadingImage()
        },
        loadingImage () {
            
            let length = Object.keys(images).length
            let loadedSet = new Set()
            console.time()
            
            let loadImage = (index, line) => {
                if (loadedSet.has(index)) {
                    loadImage(index + 1, line)
                    return
                }
                // console.log('线程:' + line)
                let image = new Image()
                image.src = images[Object.keys(images)[index]]
                loadedSet.add(index)
                image.onload = () => {
                    if (index === length -1) {
                        console.timeEnd()
                        this.loadBody()
                    } else {
                        
                        index += 1
                        loadImage(index, line)
                    }
                }
            }
            
            for (let i = 0; i < 10; i++) {
                loadImage(i, i+1)
            }
            
        },
        loadBody () {
            this.isShow = false
            this.$emit('load')
        }
    }
}
</script>
<style scoped>
.loading-body {
    position: fixed;
    width: 100%;
    height: 100%;
}
.loading-body .loading-msg {
    display: block;
    width: 90px;
    text-align: center;
    height: 70px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.loading-body .loading-msg p {
    margin: 0;
    margin-top: 15px;
}
.loading-body .loading-msg img {
    display: block;
    width: 40px;
    margin: 0 auto;
    animation: rotate 1s infinite cubic-bezier(0.42, 0, 0.09, 1.01);
}
@keyframes rotate
{
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>